export const loggerMiddleware = store => next => action => {
	console.group(action.type)
	console.log("State before:", store.getState());
	let result = next(action);
	console.log("State after:", store.getState());
	console.groupEnd();
	return result;
};
